import { render, staticRenderFns } from "./ContentDescription.vue?vue&type=template&id=5db40138&scoped=true&lang=true&"
import script from "./ContentDescription.vue?vue&type=script&lang=js&"
export * from "./ContentDescription.vue?vue&type=script&lang=js&"
import style0 from "./ContentDescription.vue?vue&type=style&index=0&id=5db40138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db40138",
  null
  
)

export default component.exports